import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from 'react-bootstrap';
import './SingleModal.css';

var SingleModal = function SingleModal(_ref) {
  var title = _ref.title,
      body = _ref.body,
      _ref$buttonText = _ref.buttonText,
      buttonText = _ref$buttonText === void 0 ? 'Delete' : _ref$buttonText,
      _ref$primaryButtonCla = _ref.primaryButtonClassName,
      primaryButtonClassName = _ref$primaryButtonCla === void 0 ? 'Btn-default-secondary' : _ref$primaryButtonCla,
      show = _ref.show,
      handleSubmit = _ref.handleSubmit,
      handleClose = _ref.handleClose;
  return React.createElement(Modal, {
    className: 'Modal-single',
    show: show,
    onHide: handleClose
  }, React.createElement(Modal.Header, null, React.createElement(Modal.Title, {
    className: 'ModalTitle'
  }, title), React.createElement('i', {
    className: 'icon-ic_close pull-right Close-modal-icon',
    onClick: handleClose
  })), React.createElement(Modal.Body, null, body), React.createElement(Modal.Footer, null, React.createElement('button', {
    className: 'Btn-outline-small Btn-outline-secondary',
    onClick: handleClose
  }, 'Cancel'), React.createElement('button', {
    className: "Btn-default-small ".concat(primaryButtonClassName),
    onClick: handleSubmit
  }, buttonText)));
};

SingleModal.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
  buttonText: PropTypes.string,
  primaryButtonClassName: PropTypes.string,
  show: PropTypes.bool,
  handleSubmit: PropTypes.func,
  handleClose: PropTypes.func
};
SingleModal.defaultProps = {
  buttonText: 'Delete',
  primaryButtonClassName: 'Btn-default-secondary'
};
export default SingleModal;